export function extractErrorMessage(error: unknown, fallback: string): string {
  if (error && typeof error === 'object') {
    const payload = error as Record<string, unknown>;
    const message = payload.error ?? payload.Error ?? payload.message ?? payload.Message;
    if (typeof message === 'string' && message.length > 0) return message;

    const data = payload.data ?? payload.Data;
    if (data != null) {
      if (typeof data === 'string' && data.length > 0) return data;

      if (typeof data === 'object') {
        const d = data as Record<string, unknown>;
        const responseData = d.data;
        if (responseData && typeof responseData === 'object') {
          const backendError = (responseData as Record<string, unknown>).Error;
          if (typeof backendError === 'string' && backendError.length > 0) return backendError;
        }

        const msg = d.message || d.Message || d.error || d.Error;
        if (msg) return String(msg);
      }
    }

    if (error instanceof Error) return error.message;
  }
  return fallback;
}
